import { getAssignedAccounts } from '../assignedAccounts'

export const handleAssignedAccountsData = data => dispatch => {
  dispatch(getAssignedAccounts())
}
